import './App.css';
import Logout from './auth/Logout'
import OnboardingForm from './form/OnboardingForm'
import ViewItem from './view/ViewItem'
import Orders from './view/Orders'
import LoginForm from './auth/LoginForm'
import RegisterUser from './auth/RegisterUser'
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import AdminDashboard from './admin/AdminDashboard';
import Expenses from './admin/Expenses';
import Coupons from './admin/Coupons';
import ServiceMonitor from './admin/ServiceMonitor';
import AiHelp from './view/AiHelp';
import ForgotPassword from './auth/ForgotPassword';
import ShopCategoryList from './view/ShopCategoryList';
import ShopCategory from './form/ShopCategory'
import ShopItemEditForm from './form/ShopItemEditForm';
import CreateItemShop from './form/CreateItemShop';
import HomePagePublic from './view/HomePagePublic';
import Navbar from './sidemenu/Navbar';
import UpdateSettings from './form/UpdateSettings';
import LandingPage from './view/LandingPage';
import CartView from './view/CartView';
import ViewYourOrder from './view/ViewYourOrder';
import AdminOrderView from './view/AdminOrderView';
import AdminOrderEachView from './view/AdminOrderEachView';
import EditItem from './view/EditItem';
import AllItemsView from './view/AllItemsView';
import Checkout from './service/payments/Checkout';
import PaymentStatus from './view/PaymentStatus';
import AppSettings from './admin/AppSettings';
import UserList from './admin/UserList';
import ScrollToTop from './components/ScrollToTop';
import SiteFooter from './components/SiteFooter';
import { ShopperOnly, SignedInShopper, StaffOnly } from './components/RoleRoute';

function App() {
  return (
    <>
      <Router>

        {/* <Helmet>
          <title>Title-app</title>
          <meta name="description" content="test page app.js" />
          <meta property="og:title" content="title-app" />
          <meta property="og:description" content='description-app' />
          <meta property="og:image" content="https://s3.ap-south-1.amazonaws.com/pinewalkers/item/default/thump/thump_1659506099957.jpg" />
        </Helmet> */}
        <ScrollToTop />
        <Navbar />
        <Switch>

          <Route exact path="/">
            <div className="">
              <ShopperOnly><LandingPage /></ShopperOnly>
            </div>
          </Route>

          <Route exact path="/items/all">
            <div className="">
              <ShopperOnly><AllItemsView /></ShopperOnly>
            </div>
          </Route>

          <Route exact path="/category/:id">
            <div className="">

              <ShopperOnly><HomePagePublic /></ShopperOnly>
            </div>
          </Route>

          <Route path="/logout">

            <Logout />
          </Route>
          <Route path="/resetPasswod">

            <ForgotPassword />
          </Route>
          <Route exact path="/payment/status/:orderId">
            <ShopperOnly><PaymentStatus /></ShopperOnly>
          </Route>
          <Route exact path="/payment">
            <ShopperOnly><Checkout /></ShopperOnly>
          </Route>

          <Route exact path="/cart">
            <div className="">

              <ShopperOnly><CartView /></ShopperOnly>
            </div>
          </Route>

          <Route exact path="/orders/view/:id">
            <div className="">

              <ShopperOnly><ViewYourOrder /></ShopperOnly>
            </div>
          </Route>

          <Route exact path="/orders/admin/view/:id">
            <div className="">

              <StaffOnly><AdminOrderEachView /></StaffOnly>
            </div>
          </Route>

          <Route exact path="/userDetails">
            <div className="">

              <OnboardingForm />
            </div>
          </Route>

          <Route exact path="/shop/inventory/item">
            <div className="">

              <StaffOnly><EditItem /></StaffOnly>
            </div>
          </Route>
          <Route exact path="/settings">
            <div className="">

              <StaffOnly><AppSettings /></StaffOnly>
            </div>
          </Route>
          <Route exact path="/profile">
            <div className="">

              <UpdateSettings />
            </div>
          </Route>
          {/* Old URL: keep bookmarks and any passed state working. */}
          <Route exact path="/settings/profile"
            render={({ location }) => <Redirect to={{ pathname: '/profile', state: location.state }} />} />
          {/* shared product links: Firebase redirects /p/:id to the preview page in production; here people just go to the product */}
          <Route exact path="/p/:id" render={({ match }) => <Redirect to={'/shop/items/view/' + encodeURIComponent(match.params.id)} />} />
          <Route exact path="/shop/items/view/:id">
            <div className="">

              <ShopperOnly><ViewItem /></ShopperOnly>
            </div>
          </Route>
          <Route exact path="/orders">
            <div className="">

              <ShopperOnly><Orders /></ShopperOnly>
            </div>
          </Route>

          <Route exact path="/admin/orders">
            <div className="">

              <StaffOnly><AdminOrderView /></StaffOnly>
            </div>
          </Route>
          <Route exact path="/admin/expenses">
            <StaffOnly><Expenses /></StaffOnly>
          </Route>
          <Route exact path="/help">
            <SignedInShopper><AiHelp /></SignedInShopper>
          </Route>
          <Route exact path="/admin/coupons">
            <StaffOnly><Coupons /></StaffOnly>
          </Route>
          <Route exact path="/admin/services">
            <StaffOnly><ServiceMonitor /></StaffOnly>
          </Route>
          <Route exact path="/admin/users">
            <StaffOnly><UserList /></StaffOnly>
          </Route>

          <Route exact path="/shop/items/list/:id">
            <div className="">
              <StaffOnly><ShopCategoryList /></StaffOnly>
            </div>
          </Route>

          <Route exact path="/shop/item/edit">
            <div className="">
              <StaffOnly><ShopItemEditForm /></StaffOnly>
            </div>
          </Route>

          <Route exact path="/shop/item/create">
            <div className="">
              <StaffOnly><CreateItemShop /></StaffOnly>
            </div>
          </Route>

          <Route exact path="/shop/inventory">
            <div className="">
              <StaffOnly><ShopCategory /></StaffOnly>
            </div>
          </Route>
          <Route exact path="/dashboard">
            <div className="">

              <StaffOnly><AdminDashboard /></StaffOnly>
            </div>
          </Route>

          <div className={``}>

            <Route path="/login" component={LoginForm} />
            <Route path="/register" component={RegisterUser} />
            {/* <Route component={Error} /> */}
          </div>

        </Switch>
        <SiteFooter />

      </Router>
    </>
  );
}

export default App;
